<template>
  <div class="qlbh">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Hợp đồng Megabiz</h1>
    </div>

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="gets">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="pt-1 font-size-12 time-placeholder">
                  Thời gian
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              v-model.trim="search.keySearch"
              type="text"
              placeholder="Từ khóa"
              style="border-radius: 4px"
              @keyup.enter="gets()"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.megabizStt"
              :options="statusMegabiz"
              placeholder="Trạng thái Megabiz"
            />
          </div>
          <div class="form-group">
            <button
              type="button"
              @click="gets()"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="clearSearch()"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng hợp đồng:
            <strong class="text-primary">{{
              objectCount.totalContract ? objectCount.totalContract : 0
            }}</strong>
            &nbsp;&nbsp;| &nbsp;&nbsp; Chưa ký:
            <strong class="text-primary">{{
              objectCount.totalNotSign ? objectCount.totalNotSign : 0
            }}</strong>
            &nbsp;&nbsp;| &nbsp;&nbsp; Đã ký:
            <strong class="text-primary">{{
              objectCount.totalSigned ? objectCount.totalSigned : 0
            }}</strong>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="listContract"
              :fields="fieldsTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(groupService)="data">
                {{ data.item.groupService | fomatTextService(dataGroupService) }}
              </template>
              <template #cell(merchant)="data">
                <p>
                  <span>{{
                    data.item.merchantData ? data.item.merchantData.merchantName : ''
                  }}</span>
                </p>
                <p
                  v-if="
                    !(
                      data.item.merchantData &&
                      data.item.merchantData.accIdType &&
                      data.item.merchantData.accIdType === 'MOBILE'
                    )
                  "
                >
                  <a href="#">{{ data.item.merchantData ? data.item.merchantData.email : '' }}</a>
                </p>
                <p>
                  <a href="#">{{
                    data.item.merchantData ? data.item.merchantData.mobile : '' | encryptPhone
                  }}</a>
                </p>
                <p>
                  <span
                    >{{ data.item.merchantData ? data.item.merchantData.address : '' }},
                    {{ data.item.merchantData ? data.item.merchantData.district : '' }},
                    {{ data.item.merchantData ? data.item.merchantData.city : '' }}</span
                  >
                </p>
                <p><Status :value="data.item.mcLvl" :config="Config.mcKeyLvl" /></p>
              </template>
              <template #cell(time)="data">
                <p>
                  HĐ:
                  <span>{{
                    data.item.typeCustomer ? data.item.typeCustomer : '' | fomatCustomtype
                  }}</span>
                </p>
                <p>
                  Số: <b>{{ data.item.code }}</b>
                </p>
                <p
                  v-if="
                    data.item.dateCreate &&
                    contractStateOther.includes(data.item.status) &&
                    data.item.formContract === 'E_CONTRACT'
                  "
                >
                  Ngày tạo: <span>{{ data.item.dateCreate | formatDate }}</span>
                </p>
                <p v-if="data.item.approvedOrRejectedDate">
                  Ngày duyệt/từ chối:
                  <span>{{ data.item.approvedOrRejectedDate | formatDate }}</span>
                </p>
                <p
                  v-else-if="
                    data.item.dateSign &&
                    ((contractStateSign.includes(data.item.status) &&
                      data.item.formContract === 'E_CONTRACT') ||
                      data.item.formContract === 'PAPER_CONTRACT') &&
                    data.item.status !== 'CANCELED'
                  "
                >
                  Ngày ký: <span>{{ data.item.dateSign | formatDate }}</span>
                </p>
                <p v-else-if="data.item.dateCancel && data.item.status === 'CANCELED'">
                  Ngày huỷ: <span>{{ data.item.dateCancel | formatDate }}</span>
                </p>
              </template>
              <template #cell(appendix)="data">
                <div v-if="data.item.codeAppendixList">
                  <p v-for="(appendixItem, index) in data.item.codeAppendixList" :key="index">
                    <b>{{ appendixItem }}</b>
                  </p>
                </div>
              </template>
              <template #cell(devices)="data">
                <div v-if="data.item.numDevices && data.item.numDevices !== 0">
                  <p>
                    SL: <span>{{ data.item.numDevices }}</span>
                  </p>
                  <p>
                    TT:
                    <span>{{
                      data.item.priceDevices ? data.item.priceDevices : 0 | fomatCurrency
                    }}</span>
                  </p>
                </div>
              </template>
              <template #cell(sale)="data">
                <p>
                  <b>{{ data.item.saleInfo ? data.item.saleInfo.name : '' }}</b>
                </p>
                <p>
                  <a href="#">{{ data.item.saleInfo ? data.item.saleInfo.userName : '' }}</a>
                </p>
                <p>{{ data.item.saleInfo ? data.item.saleInfo.regionName : '' }}</p>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.megabizStt ? data.item.megabizStt : '']">
                  {{ data.item.megabizStt | mapTextStatus(statusMegabiz) }}</span
                >
                <br />
                {{ data.item.stateCollaborator | mapTextStatus(listStateCollaborator) }}
              </template>
              <template #cell(action)="data">
                <b-dropdown
                  class="text-center"
                  variant="outline-light"
                  v-if="dataPermission && dataPermission.includes('CNPS_SCON_INFO_BY_CODE')"
                >
                  <b-dropdown-item
                    type="button"
                    class="dropdown-item"
                    @click="openModalDetail(data.item)"
                  >
                    <i class="bx bx-show-alt"></i> Chi tiết
                  </b-dropdown-item>
                  <!-- <b-dropdown-item v-if="data.item.groupService === 'SELL' && data.item.status === 'APPROVED'"
                      type="button"
                      class="dropdown-item"
                      @click="activeModal(data.item.id)">
                      <span class="mr-2">√</span> Đã kích hoạt
                    </b-dropdown-item> -->
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="totalRows"
          :per-page="search.limit"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>
    <b-modal id="active-mc">
      <template #modal-header="{ close }">
        <h5>Kích hoạt</h5>
        <b-button size="sm" variant="light" @click="close(), (textNote = '')">x</b-button>
      </template>

      <template #default="{}">
        <h6 class="text-center">Nhập ghi chú</h6>
        <input v-model="textNote" />
      </template>

      <template #modal-footer="{}">
        <b-button variant="primary" @click="activeMC">OK</b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { SalesManagerService } from '@/services/sales-manager.service'
  import { ContractService } from '../../services/contract.service'
  import Config from '../../thirdParty/config'
  import moment from 'moment'
  import { mapGetters } from 'vuex'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    // { key: 'groupService', label: 'Nhóm dịch vụ', thStyle: 'min-width: 80px' },
    { key: 'merchant', label: 'Merchant', thStyle: 'min-width: 130px' },
    { key: 'time', label: 'Hợp đồng/Ngày ký', thStyle: 'min-width: 280px' },
    { key: 'appendix', label: 'Phụ lục' },
    { key: 'devices', label: 'Thiết bị', thStyle: 'min-width: 120px' },
    { key: 'sale', label: 'Sale' },
    { key: 'status', label: 'Trạng thái Megabiz' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  export default {
    data() {
      return {
        showUpdateStatusModal: false,
        Config,
        fieldsTable,
        contractActiveId: '',
        textNote: '',
        dateRange: {
          startDate: null,
          endDate: null,
        },
        search: {
          limit: 15,
          page: 1,
        },
        dataGroupService: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        listContract: [],
        objectCount: {},
        totalRows: 0,
        loading: false,
        showLoading: false,
        contractStateSign: [
          'SIGNED_MISS_IMAGE',
          'SIGNED_WAITING_APPROVED',
          'APPROVED',
          'LIQUIDATE',
          'REJECTED_SA',
          'ADDITIONAL',
        ],
        contractStateOther: [
          'NEW',
          'WAITING_APPROVED_FEE',
          'APPROVED_FEE',
          'SENT',
          'WAITING_SIGN',
          'SIGNING',
          'REJECTED_MC',
          'REJECTED_MA',
        ],
        listStateCollaborator: [
          { id: 0, text: 'Tất cả' },
          { id: 'APPROVED', text: 'GS đã duyệt' },
          { id: 'WAITING', text: 'Chờ GS duyệt' },
          { id: 'REJECTED', text: 'GS từ chối' },
        ],
        statusMegabiz: [],
      }
    },

    watch: {
      'search.page': function () {
        this.gets()
      },
      'search.limit': function () {
        this.gets()
      },
    },

    created() {
      this.gets()
      this.fetchDataDevice()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      activeModal(data) {
        this.$bvModal.show('active-mc')
        this.contractActiveId = data
      },

      async activeMC() {
        try {
          this.loading = true
          this.$bvModal.hide('active-mc')
          const data = await SalesManagerService.activeMerchant({
            contractId: this.contractActiveId,
            note: this.textNote,
          })
          if (data.success) {
            this.showSuccesMx('Đã kích hoạt')
            await this.gets()
          } else {
            this.showFailMx(data.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
          this.textNote = ''
        }
      },

      openModalDetail(data) {
        if (data.groupService === 'SELL') {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/sales-manager/detail/${encodeURIComponent(data.id)}`, '_blank')
          } else {
            window.open(`/sales-manager/detail-paper/${encodeURIComponent(data.id)}`, '_blank')
          }
        } else {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/contract-detail-ecommerce/${encodeURIComponent(data.id)}`, '_blank')
          } else {
            window.open(`/contract-detail-paper/${encodeURIComponent(data.id)}`, '_blank')
          }
        }
      },

      clearSearch() {
        this.search = {
          page: 1,
          limit: 15,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.gets()
      },

      async formatData() {
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()

        for (const key in this.search) {
          if (this.search[key] === '0') delete this.search[key]
        }

        if (this.search.code && this.search.code.includes(' ')) {
          const index = this.search.code.indexOf(' ')
          const length = this.search.code.length
          const code = this.search.code.slice(0, index) + this.search.code.slice(index + 1, length)
          this.search.code = code
        }
      },

      async gets() {
        try {
          this.loading = true
          this.formatData()
          const data = await ContractService.getListContractMegabiz(this.search)
          if (data.code === 1000) {
            this.objectCount = {
              totalContract: data.totalPage.total,
              totalNotSign: data.data.totalNotSign,
              totalSigned: data.data.totalSigned,
            }
            this.totalRows = data.totalPage.total
            this.listContract = data.data.contractList
            return
          }
          this.listContract = []
        } catch (error) {
          console.log(error, '=========>')
        } finally {
          this.loading = false
        }
      },

      async fetchDataDevice() {
        try {
          this.loading = true
          const data = await ContractService.getListStatusMegabiz({})
          if (data.success) {
            const list = data.data.contractStt || []
            this.statusMegabiz = list.map(e => ({
              id: e.code,
              text: e.name,
              ...e,
            }))
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },

    filters: {
      serviceTypes(itemm) {
        const listServiceTypes = Config.listServiceTypes
        return listServiceTypes[itemm] ? listServiceTypes[itemm] : itemm
      },
    },
  }
</script>

<style>
  @media screen and (max-width: 480px) {
    .dropdown-menu {
      max-width: 100%;
    }
    .no-gutters {
      overflow-x: auto;
      max-width: 100%;
      margin: 0 auto;
    }
    .daterangepicker .drp-buttons .btn {
      margin-left: 0;
    }
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px;
  }

  .DONE,
  .ACTIVE {
    color: #fff;
    background-color: #007bff;
  }
  .PENDING_APPROVAL,
  .PENDING_CONFIRM_APPROVAL {
    color: #fff;
    background-color: #ffc107;
  }
  .CANCEL {
    color: #fff;
    background-color: #dc3545;
  }
</style>
